import React, { useState,useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

const IndividualSignupPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();

  // ✅ S3 base host from .env (React env must start with REACT_APP_)
  // Example:
  // REACT_APP_S3_IMAGES_BASE=https://bucket-datastore-mark1.s3.ap-south-1.amazonaws.com/Images
  const ICONS_BASE = (process.env.REACT_APP_S3_ICONS_BASE || "").replace(/\/$/, "");
  const IMAGES_BASE = (process.env.REACT_APP_S3_IMAGES_BASE || "").replace(/\/$/, "");


  // ✅ helper to build icons url
  const img = (fileName) => {
    const url = `${IMAGES_BASE}/${fileName}`;
    console.log("Generated URL:", url); // Debug log
    return url;
  };

  const ico = (fileName) => {
    const url = `${ICONS_BASE}/${fileName}`;
    console.log("Generated URL:", url); // Debug log
    return url;
  };

  // ✅ Debug: Log the base URL on component mount
  useEffect(() => {
    
    console.log("IMAGE_BASE:", ICONS_BASE);
    console.log("Sample URL:", ico("logo-header.png"));
  }, []);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    const result = await register({
      name: formData.name,
      email: formData.email,
      password: formData.password,
      user_type: 'individual',
      timezone: formData.timezone
    });

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message || 'Registration failed. Please try again.');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-page">
    <div className="login-wrapper">
      {/* LEFT PANEL */}
      <div className="left-panel">
        <div className="logo-circle">
          <img src={ico("login-logo.svg")} alt="Logo" />
        </div>

        <h2>Sign Up to your Account</h2>
        <p className="subtext">Welcome! Please Create Your Account To get Started</p>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Full Name */}
          <label htmlFor="name">Full Name</label>
          <div className="input-field">
            <img src={ico("user.svg")} className="input-icon" alt="" />
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          {/* Email */}
          <label htmlFor="email">Email</label>
          <div className="input-field">
            <img src={ico("mail.svg")} className="input-icon" alt="" />
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          {/* Timezone */}
          <label htmlFor="timezone">Timezone</label>
          <div className="input-field">
            <img src={ico("user.svg")} className="input-icon" alt="" />
            <select
              id="timezone"
              name="timezone"
              value={formData.timezone}
              onChange={handleChange}
              required
            >
              <option value="Asia/Kolkata">(IST) Asia/Kolkata</option>
              <option value="Europe/London">(UK) Europe/London</option>
              <option value="America/New_York">(US) America/New_York</option>
              <option value="America/Los_Angeles">(US) America/Los_Angeles</option>
              <option value="Australia/Sydney">(AUS) Australia/Sydney</option>
            </select>
          </div>

          {/* Password */}
          <label htmlFor="password">Password</label>
          <div className="input-field">
            <img src={ico("lock.svg")} className="input-icon" alt="" />
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
            />
          </div>

          {/* Confirm Password */}
          <label htmlFor="confirmPassword">Confirm Password</label>
          <div className="input-field">
            <img src={ico("lock.svg")} className="input-icon" alt="" />
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm password"
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Sign up'}
          </button>
        </form>

        <p className="create-account">
          Already have an account?
          <Link to="/login"> Log in</Link>
        </p>
        <Link to="/signup" className="back-home">← Back to Account Type</Link>
      </div>

      {/* RIGHT PANEL */}
      <div className="right-panel">
        <img src={img("bg-graphic.png")} className="bg-graphic" alt="" />
        <img src={img("login-illustration.png")} className="main-image" alt="" />

        <img src={ico("Instagram.png")} className="floating-icon insta" alt="" />
        <img src={ico("facebook.png")} className="floating-icon fb" alt="" />
        <img src={ico("linkedin.png")} className="floating-icon li" alt="" />

        <p className="connect-text">Connect with Any Socials</p>
      </div>
    </div>
    </div>
  );
};

export default IndividualSignupPage;
